import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectVehicleAttributionComponent } from './select-vehicle-attribution.component';
import { NzIconModule } from 'ng-zorro-antd/icon';

@NgModule({
  declarations: [
    SelectVehicleAttributionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    NzFormModule,
    NzSelectModule,
    NzIconModule
  ],
  exports: [
    SelectVehicleAttributionComponent
  ]
})
export class SelectVehicleAttributionModule {}
